// Extracted verbatim from careers.co.jp routes/candidate/BigFive.tsx so the
// questionnaire and the results view can both render the same credit line.
// Required by the bigfive-org MIT license / IPIP attribution.

export function Attribution({ lang }: { lang: "en" | "ja" }) {
  return (
    <p className="mt-6 text-[11px] leading-relaxed text-ink-muted">
      {lang === "ja"
        ? "設問はIPIP-NEO-120（パブリックドメイン、International Personality Item Pool）を使用。日本語訳はオープンソースのbigfive-orgプロジェクト（MITライセンス）を利用しています。"
        : "Assessment items: IPIP-NEO-120 (public domain, International Personality Item Pool). Japanese translation from the open-source bigfive-org project (MIT license)."}
    </p>
  );
}
